import React from 'react';
import { unescapeHtml } from '../../utils/stringUtils';
import { Template } from '../types';
import PropTypes from 'prop-types';

const isSSR = typeof window === 'undefined';

type FooterSectionProps = {
  template: Template;
};

export default function FooterSection({ template }: FooterSectionProps) {
  const html = isSSR ? template.footer_data : unescapeHtml(template.footer_data);

  return (
    <footer
      className="new-footer-wrapper"
      dangerouslySetInnerHTML={{
        __html: html
      }}
    />
  );
}

FooterSection.propTypes = {
  template: PropTypes.object
};
